import { ClinicalToolsSection } from "@/components/ClinicalToolsSection";

/** Clinician tool library. Members only: moved off the public site on 2026-10-18. */
export default function BoardResources() {
  return (
    <div>
      <header className="pb-board-page-heading">
        <div>
          <p className="pb-board-eyebrow">For clinicians</p>
          <h1>Tools</h1>
          <p>GP tools and calculators based on Australian guidelines.</p>
        </div>
      </header>
      <ClinicalToolsSection />
    </div>
  );
}
